// src/components/StackedCards.jsx
import bamboo from "../assets/bamboo.png";
import cotton from "../assets/cotton.png";
import ihram from "../assets/ihram.png";

import { FaQuoteLeft } from "react-icons/fa";
import { motion } from "framer-motion";


export default function StackedCards() {
  return (
    <div
      className="relative h-[320vh] bg-cover bg-center bg-no-repeat  "
      style={{ backgroundImage: `url(/startImg.webp)` }}
    >
      {/* Heading */}
      <div className="flex flex-col align-center justify-center  ">
        <h1 className="text-5xl md:text-6xl font-bold flex justify-center pt-2 text-center mt-12  ">
          Our Premium Collections
        </h1>
        <h3 className="font-sans text-xl md:text-xl text-blue-950 flex justify-center mt-6 text-center px-4">
          Luxury in cotton, purity in bamboo, and tradition in Ihram.
        </h3>
      </div>

      {/* Card 1 */}
      <section className="sticky top-0 h-screen z-10 flex items-center justify-center ">
        <div className="w-[min(92vw,1000px)] h-auto md:h-[70vh] rounded-3xl shadow-2xl bg-white flex flex-col md:flex-row p-4 -mt-[70px] md:mt-0">

          <motion.img
            src={bamboo}
            className="w-full md:w-[50%] h-[250px] md:h-[90%] rounded-3xl object-cover cursor-pointer mr-2 mt-2"
            alt="box1"
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
          />
          <div className="pt-4 md:pt-0 md:pb-6 md:pl-4 flex flex-col justify-center">
            <h1 className="text-blue-950 text-3xl md:text-6xl font-semibold">
              Luxury Bamboo Towels
            </h1>
            <p className="text-blue-950 text-base md:text-xl pt-4 md:pt-10">
              <FaQuoteLeft className="text-xl md:text-3xl mb-2" />
              Experience the unmatched softness of 100% pure bamboo. Silky
              smooth, highly absorbent, and eco friendly, crafted for comfort
              you can truly feel. Gentle on your skin, perfect for everyday use.
              Sustainable luxury that makes a difference for the planet.
            </p>
          </div>
        </div>
      </section>

      {/* Card 2 */}
      <section className="sticky top-0 h-screen z-20 flex items-center justify-center">
        <div className="  w-[min(92vw,1000px)] h-auto md:h-[70vh] rounded-3xl shadow-2xl bg-white flex flex-col md:flex-row p-4 ">
          <motion.img
            src={cotton}
            className="w-full md:w-[50%] h-[250px] md:h-[90%] rounded-3xl object-cover cursor-pointer  mr-2 mt-2"
            alt="box2"
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
          />
          <div className="pt-4 md:pt-0 md:pb-6 md:pl-4 flex flex-col justify-center">
            <h1 className="text-blue-950 text-3xl md:text-6xl font-semibold">
              Premium Cotton Towels
            </h1>
            <p className="text-blue-950 text-base md:text-xl pt-4 md:pt-10">
              <FaQuoteLeft className="text-xl md:text-3xl mb-2" />
              Indulge in the timeless luxury of 100% premium cotton. Soft, plush
              and absorbent, crafted to transform daily moments into spa-like
              experiences. Durable yet gentle, blending comfort with elegance,
              offering sophistication you can wrap yourself in.
            </p>
          </div>
        </div>
      </section>

      {/* Card 3 */}
      <section className="sticky top-0 h-screen z-30 flex items-center justify-center">
        <div className="w-[min(92vw,1000px)] h-auto md:h-[70vh] rounded-3xl shadow-2xl bg-white flex flex-col md:flex-row p-4">
          <motion.img
            src={ihram}
            className="w-full md:w-[50%] h-[250px] md:h-[90%] rounded-3xl object-cover cursor-pointer  mr-2 mt-2"
            alt="box3"
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 300, damping: 20 }}
          />
          <div className="pt-4 md:pt-0 md:pb-6 md:pl-4 flex flex-col justify-center">
            <h1 className="text-blue-950 text-3xl md:text-6xl font-semibold">
              Pilgrim Ihram Towels
            </h1>
            <p className="text-blue-950 text-base md:text-xl pt-4 md:pt-10">
              <FaQuoteLeft className="text-xl md:text-3xl mb-2" />
              Embrace the purity and comfort of Ihram towels designed for your
              sacred journey. Lightweight, absorbent and breathable, gentle on
              the skin and crafted to reflect simplicity and devotion, bringing
              peace and ease throughout your pilgrimage.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
